@if (tour.active(); as active) {
  <section
    class="guided-tour"
    data-testid="guided-tour"
    [class.guided-tour--mobile]="layout().mobile">
    <div
      class="guided-tour__backdrop"
      data-testid="guided-tour-backdrop"
      aria-hidden="true"></div>

    <svg
      class="guided-tour__mask"
      aria-hidden="true"
      focusable="false">
      <path
        class="guided-tour__dim"
        fill-rule="evenodd"
        [attr.d]="layout().maskPath" />
    </svg>

    <div
      class="guided-tour__ring"
      data-testid="guided-tour-ring"
      aria-hidden="true"
      [style.top.px]="layout().spot.top"
      [style.left.px]="layout().spot.left"
      [style.width.px]="layout().spot.width"
      [style.height.px]="layout().spot.height"></div>

    @if (tour.currentStep(); as step) {
      <div
        #popover
        class="guided-tour__popover"
        data-testid="guided-tour-popover"
        role="dialog"
        aria-modal="true"
        aria-labelledby="guided-tour-title"
        aria-describedby="guided-tour-description"
        tabindex="-1"
        [style.top]="layout().popover.top"
        [style.bottom]="layout().popover.bottom"
        [style.left]="layout().popover.left"
        [style.width]="layout().popover.width">
        <p
          class="guided-tour__progress"
          data-testid="guided-tour-progress">
          {{ tour.stepNumber() }} de {{ tour.totalSteps() }}
        </p>
        <h2
          id="guided-tour-title"
          class="guided-tour__title">
          {{ step.title }}
        </h2>
        <p
          id="guided-tour-description"
          class="guided-tour__description">
          {{ step.description }}
        </p>

        <div class="guided-tour__actions">
          <button
            type="button"
            class="guided-tour__skip"
            data-testid="guided-tour-skip"
            (click)="tour.skip()">
            Pular apresentação
          </button>

          <div class="guided-tour__nav">
            @if (!tour.isFirstStep()) {
              <button
                pButton
                type="button"
                class="p-button-outlined p-button-sm"
                data-testid="guided-tour-back"
                (click)="tour.back()">
                <lucide-icon
                  name="arrow-left"
                  [size]="14"
                  aria-hidden="true" />
                <span>Voltar</span>
              </button>
            }
            <button
              pButton
              type="button"
              class="p-button-sm"
              [attr.data-testid]="tour.isLastStep() ? 'guided-tour-finish' : 'guided-tour-next'"
              (click)="tour.next()">
              <span>{{ tour.isLastStep() ? 'Concluir' : 'Próximo' }}</span>
              <lucide-icon
                [name]="tour.isLastStep() ? 'check' : 'arrow-right'"
                [size]="14"
                aria-hidden="true" />
            </button>
          </div>
        </div>
      </div>

      <p
        class="guided-tour__sr-only"
        role="status"
        aria-live="polite">
        Etapa {{ tour.stepNumber() }} de {{ tour.totalSteps() }}: {{ step.title }}
      </p>
    }
  </section>
}
